import { GoogleTagManagerService } from './../../services/analytics/google-tag-manager.service';
import { Directive, OnInit, Input, Output, OnDestroy, ElementRef, EventEmitter, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import * as Cookies from 'js-cookie/src/js.cookie.js';
import $ from 'jquery';
import '../../../vendors/typeahead.jquery.js';
import { FormControl } from '@angular/forms';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { SearchService } from 'app/services/search/search.service';
import { environment } from '../../../environments/environment';
import { LANG_EN_TRANS } from '../../../translation/lang-en';
import { LANG_TH_TRANS } from '../../../translation/lang-th';
import { Language, SuggestionCategory } from '../../model/constant';
import { domain } from 'environments/properties';

@Directive({
  selector: '[typeahead]'
})
export class TypeaheadDirective implements OnInit, OnDestroy, AfterViewInit {
  @Input('typeahead') formControl: FormControl;
  @Input('valueControls') valueControls: FormControl;
  @Output('onSelectedItem') onSelectedItem = new EventEmitter();
  @Input()
  set objective(objective: string) {
    if (objective) {
      this._objective = objective;
    }
  }

  public _objective = 'work';
  private suggestionData: any = '';
  private actionSelectItem: boolean = false;
  private hasSelectedAll: boolean = false;
  private dataSelected: boolean;
  private searchData: any = { 'hotel': {} };
  private getSearchSuggestionRef: any;

  private suggestionResData = new Subject<any>();
  private suggestionResDataCountryRef: any;
  private formSubRef: any;
  private langSubRef: any;

  constructor(
    private elementRef: ElementRef,
    private appConfigService: AppConfigService,
    private searchService: SearchService,
    private googleTagManagerService: GoogleTagManagerService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    // Get Translate
    const translate = (value) => {
      switch (this.appConfigService.getLanguage()) {
        case Language.th:
          return LANG_TH_TRANS[value];
        case Language.en:
          return LANG_EN_TRANS[value];
      }
    };

    // Call typeahead library to Generate Component.
    // typeahead ------------------------------------------------------------------------------------
    let _self = this;

    $(function () {
      let $element = $(_self.elementRef.nativeElement);
      let selected = [];
      let typeaheadConfig = { timeInitial: 500, instantiated: false };
      let historyConfig = { key: AppConfigService.localStorageSearchHistoryName, limit: 7 };
      let searchHistory;
      let countSuggestion = 0;

      $element.on('click', function ($event) {
        if (!_self.hasSelectedAll) {
          _self.hasSelectedAll = true;
          try {
            // IOs, Safari, throws exception on Chrome etc
            this.selectionStart = 0;
            this.selectionEnd = this.value.length + 1;
          } catch (err) {
            // Non IOs option if not supported, e.g. Chrome
            this.select();
          }
        }
      });

      // On blur reset hasSelectedAll to allow full select
      $element.on('blur', function ($event) {
        _self.hasSelectedAll = false;
      });

      $element.blur(function (e) {
        // if (!_self.dataSelected) {
        //   $(this).closest('.twitter-typeahead').find('.tt-suggestion:first-child').trigger('click');
        // }
      });



      // Watch
      _self.formSubRef = _self.formControl.valueChanges.subscribe(newValue => {
        if (newValue && _self.actionSelectItem === false) {
          $element.typeahead('val', newValue);
          $element.value = newValue;
          $element.closest('.twitter-typeahead').find('.tt-suggestion:first-child').trigger('click');
          _self.dataSelected = true;
        } else if (newValue == '') {
          $element.typeahead('val', newValue);
          $element.value = newValue;
        }
      });

      searchHistory = {
        load: function () {
          let currentLang = _self.appConfigService.getLanguage();
          let history;
          try {
            history = localStorage.getItem(historyConfig.key);
            if (history == null) {
              localStorage.setItem(historyConfig.key, JSON.stringify([]));
            } else {
              history = JSON.parse(history);
            }
          } catch (err) {
            history = Cookies.get(historyConfig.key);
            if (history == null) {
              Cookies.set(historyConfig.key, JSON.stringify([]), { domain: domain });
            } else {
              history = JSON.parse(history);
            }
          }
          return history || [];
        },

        sorting: function (data, histories) {
          // remove history existing and increase sorting number
          histories = histories.filter(function (item) {
            if (data.id != item.id) {
              return Object.assign(item, { sortNumber: ++item.sortNumber });
            }
          });

          data.type = 'history';
          histories.push(Object.assign(data, { sortNumber: 0 })); // add latest history

          // sorted by sortNumber
          histories.sort(function (a, b) {
            return a.sortNumber - b.sortNumber;
          });

          return histories;
        },

        update: function (data) {
          let currentLang = _self.appConfigService.getLanguage();
          let histories = this.sorting(data, this.load()); // load => add => sort

          // remove overflow history
          histories = histories.filter(function (item, index) {
            if (index < historyConfig.limit) {
              return item;
            }
          });

          // save data
          try {
            localStorage.setItem(historyConfig.key, JSON.stringify(histories));
          } catch (err) {
            Cookies.set(historyConfig.key, JSON.stringify(histories), { domain: domain });
          }
        }
      };

      const selectItem = function (e, datum, dataset) {
        _self.dataSelected = true;
        _self.actionSelectItem = true;

        let type = datum.type;
        if (datum.suggestCat != SuggestionCategory.NEAR_BY) {
          searchHistory.update(datum);
        }
        else {
          _self.actionSelectItem = false;
        }

        _self.valueControls.patchValue({
          id: datum.id,
          title: datum.suggestCat != SuggestionCategory.NEAR_BY ? datum.title : _self.appConfigService.getTranslate('search-box-near-by-you'),
          suggestCat: datum.suggestCat,
          slug: datum.slug,
          poi: datum.suggestCat === SuggestionCategory.POINT_OF_INTEREST ? datum.poi : null,
          destinationId: datum.destinationId,
          destinationTitle: datum.destinationTitle,
          type: type,
        });
        _self.actionSelectItem = true;

        _self.onSelectedItem.emit({ data: datum });
        $element.blur();
      };

      let fetchDataTimer;
      const dataCountry = function (q, sync, async) {
        // Call API
        clearTimeout(fetchDataTimer);
        fetchDataTimer = setTimeout(() => {
          if (_self.valueControls.value.suggestCat != SuggestionCategory.NEAR_BY) {
            if (q.length > 0) {
              countSuggestion = 0;

              if (_self.getSearchSuggestionRef) {
                _self.getSearchSuggestionRef.unsubscribe();
              }
              const req = {
                str: q,
                lang: _self.appConfigService.getLanguageId(),
                lat: Cookies.get(AppConfigService.lat) !== undefined ? Cookies.get(AppConfigService.lat) : null,
                lon: Cookies.get(AppConfigService.lon) !== undefined ? Cookies.get(AppConfigService.lon) : null,
                companyId: JSON.parse(decodeURIComponent(window.atob(Cookies.get(AppConfigService.userInfoCookieName)))).companyId,
                objective: _self._objective
              };


              _self.getSearchSuggestionRef = _self.searchService.getSearchSuggestion(req).subscribe(data => {
                _self.googleTagManagerService.emitEvent('Search Suggestion', 'Search', q, data.length || 0);
                _self.suggestionResData.next(data);
              });
            }
          }
        }, 500);

        if (_self.suggestionResDataCountryRef) {
          _self.suggestionResDataCountryRef.unsubscribe();
        }
        _self.suggestionResDataCountryRef = _self.suggestionResData.asObservable().subscribe(data => {
          const filterData = [];
          data.forEach(function (obj) {
            obj.type = 'suggestion';
            filterData.push(obj);
          });
          async(filterData);
        });
      };

      const historyWithDefaults = function (q, sync, async) {
        if (q === '') {
          countSuggestion = 0;
          _self.suggestionResDataCountryRef ? _self.suggestionResDataCountryRef.unsubscribe() : '';
          const currentHistory = searchHistory.load();
          sync(currentHistory);
        }
      };

      const nearBy = function (q, sync, async) {
        if (q === '') {
          countSuggestion = 0;
          _self.suggestionResDataCountryRef ? _self.suggestionResDataCountryRef.unsubscribe() : '';
          let nearby = [];
          nearby.push({
            "id": null,
            "lang": _self.appConfigService.getLanguageId(),
            "slug": "",
            "suggestCat": "nearby",
            "title": _self.appConfigService.getLanguageId() == '2' ? "ค้นหาจากตำแหน่งของคุณ" : "Nearby location",
            "destinationTitle": "",
            "countryTitle": "",
            "sortNumber": 0,
            "type": 'nearby',
        })
        sync(nearby)
        }
      }

      const suggestionTemplate = function (data) {
        if (_self.suggestionData === '' || _self.suggestionData._query != data._query) {
          _self.suggestionData = data;
        }

        const idSuggestion = 'item-suggestion-' + countSuggestion++;
        const dataCount = data.count > 0 ? true : false;
        const dataTitle = data.title ? data.title : '-';
        const destination = data.destinationTitle ? data.destinationTitle : '';
        const country = data.countryTitle ? data.countryTitle : '';

        let ic = '';
        let sub = '';
        switch (data.suggestCat) {
          case 'product':
            ic = 'hotel';
            sub = destination + ', ' + country;
            break;
          case 'pointofinterest':
            ic = 'poi';
            destination ? sub = destination + ', ' + country : sub = country;
            break;
          case 'nearby':
            ic = 'nearby';
            break;
          default:
            ic = 'pin';
            sub = country;
            break;
        }

        // set icon
        const icon = '<div class="suggestion-icon"><i class="recent-suggest-icon icon-' + ic + '"></i></div>';

        // set content
        const title = '<div class="suggestion-title">' + dataTitle + '</div>';
        const subtitle = '<div class="suggestion-subtitle">' + sub + '</div>';
        const content = '<div class="suggestion-content' + (!dataCount ? ' full' : '') + '">' + title + subtitle + '</div>';

        // set count destination
        const countDest = dataCount ? '<div class="suggestion-count">' + data.count + ' ' + translate('search-box-props') + '</div>' : '';

        return '<div id="' + idSuggestion + '">' + icon + content + countDest + '</div>';
      };

      setTimeout(function () {
        $element.typeahead({
          highlight: true,
          hint: false,
          minLength: 0,
          order: 'asc',
          limit: 'Infinity',
        }, {
          name: 'product',
          displayKey: 'title',
          source: dataCountry,
          limit: 8,
          templates: {
            // header: '<p class="tt-dataset tt-header">' + translate('search-box-result-search') + '</p>',
            suggestion: suggestionTemplate
          }
        }
        , {
          name: 'nearby',
          displayKey: 'title',
          source: nearBy,
          templates: {
            suggestion: suggestionTemplate
          }
        }
        , {
          name: 'history',
          displayKey: 'title',
          source: historyWithDefaults,
          limit: 8,
          templates: {
            header: '<p class="tt-dataset tt-header">' + translate('search-box-recent-searches') + '</p>',
            suggestion: suggestionTemplate
          }
        }).bind('typeahead:selected', selectItem);
        typeaheadConfig.instantiated = true;

      }, typeaheadConfig.timeInitial);

      // Detection Change Language.
      _self.langSubRef = _self.appConfigService.getLanguageObs().subscribe(
        lang => {
          $element.typeahead('destroy');
          $element.typeahead({
            highlight: true,
            hint: false,
            minLength: 0,
            order: 'asc',
            limit: 'Infinity',
          }, {
            name: 'product',
            displayKey: 'title',
            source: dataCountry,
            limit: 8,
            templates: {
              header: '<p class="tt-dataset tt-header">' + translate('search-box-result-search') + '</p>',
              suggestion: suggestionTemplate
            }
          },
          {
            name: 'nearby',
            displayKey: 'title',
            source: nearBy,
            templates: {
              suggestion: suggestionTemplate
            }
          },
          {
            name: 'history',
            displayKey: 'title',
            source: historyWithDefaults,
            limit: 8,
            templates: {
              header: '<p class="tt-dataset tt-header">' + translate('search-box-recent-searches') + '</p>',
              suggestion: suggestionTemplate
            }
          }).bind('typeahead:selected', selectItem);
        }
      );

      // end typeahead ------------------------------------------------------------------------------------
    });
  }

  ngOnDestroy(): void {
    // UnSubscribe ALL.
    this.getSearchSuggestionRef ? this.getSearchSuggestionRef.unsubscribe() : '';
    this.suggestionResDataCountryRef ? this.suggestionResDataCountryRef.unsubscribe() : '';
    this.formSubRef ? this.formSubRef.unsubscribe() : '';
    this.langSubRef ? this.langSubRef.unsubscribe() : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/typeahead/typeahead.directive.ts